/*
  AMC HOMEPAGE QUICK ADD (2026-10-11; one-button update 2026-10-22).
  2026-10-22: every homepage card shows one blue "Add To Cart". Quote/PO actions live on the product page only.
  Built-to-order products (walk-ins, door/hinge coolers, builders) open a side flyout with photo, live
  price and built-in savings, then hand off to the product page builder (their required choices are line
  item properties, so they are never added from a card). Loaded on the homepage only by snippets/amc-bright-2026.liquid.
  1) Every in-stock homepage card is an "Add to Cart":
     - Cards that already open the options flyout ("Choose Options") are relabelled.
     - Link-only cards (walk-in coolers, "Shop equipment by category") fetch sections/amc-quick-add.liquid
       for that product. One variant: it is added and the cart flyout opens. Several variants: the options
       flyout opens first, then the cart flyout.
  2) The options flyout is upgraded in place: product photo, live price and saving, tap-to-choose option
     buttons (long lists stay as menus), unavailable choices greyed out, quantity, and a pinned Add to Cart.
  All adds go through the existing controller in assets/amc-home-cart.js (form[data-amc-home-cart-form]).
  Without this script the cards keep their original links and the original flyout.
*/
(() => {
  if (window.__amcQuickAdd) return;
  window.__amcQuickAdd = true;

  const LABEL = 'Quick add';
  const LINKS = 'a.amc-market-card__cta:not(.amc-market-card__atc), a.amc-equipment-product__link, a.amc-cslider__quick';
  const CARD = '.amc-market-card, .amc-equipment-product, .amc-cslider__card, .amc-trending-card, product-card, .product-card-wrapper';
  const hosts = new Map();
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
  }).format(cents / 100);

  const P = 'html:not(#a):not(#b):not(#c) body.index-template .amc-card-option-modal';
  const CSS = `@layer amcbright{
${P} .popup-modal__content{padding:0!important;background:#fff!important}
${P} .popup-modal__toggle{position:absolute!important;top:12px!important;right:12px!important;z-index:6!important;width:40px!important;height:40px!important;margin:0!important;border:1px solid #E6E8EC!important;border-radius:999px!important;background:#fff!important;box-shadow:0 2px 8px rgba(6,26,53,.12)!important}
${P} .amc-quick-add-guidance{position:sticky!important;top:0!important;z-index:3!important;padding:16px 64px 14px 16px!important;border-bottom:1px solid #E6E8EC!important;background:#fff!important;color:#061A35!important}
${P} .amc-quick-add-guidance.is-upgraded{display:grid!important;grid-template-columns:76px minmax(0,1fr)!important;gap:4px 14px!important;align-items:center!important}
${P} .amc-qa-thumb{grid-row:1 / span 3!important;display:block!important;width:76px!important;height:76px!important;border-radius:14px!important;background:#F5F5F7!important;overflow:hidden!important}
${P} .amc-qa-thumb img{display:block!important;width:100%!important;height:100%!important;padding:6px!important;object-fit:contain!important;mix-blend-mode:multiply!important}
${P} .amc-qa-kicker{font-size:11px!important;font-weight:500!important;letter-spacing:0!important;text-transform:none!important;color:#5E7080!important}
${P} .amc-qa-title{display:-webkit-box!important;-webkit-line-clamp:2!important;-webkit-box-orient:vertical!important;overflow:hidden!important;font-size:15.5px!important;font-weight:600!important;line-height:1.3!important;color:#061A35!important}
${P} .amc-qa-price{display:flex!important;flex-wrap:wrap!important;align-items:baseline!important;gap:4px 8px!important;font-size:17px!important;font-weight:600!important;color:#17344A!important}
${P} .amc-qa-price s{font-size:13px!important;font-weight:500!important;color:#5E7080!important}
${P} .amc-qa-price em{padding:0!important;border-radius:0!important;background:transparent!important;color:#476272!important;font-size:11px!important;font-style:normal!important;font-weight:500!important}
${P} .amc-card-option-modal__body{gap:16px!important;padding:18px 16px 0!important}
${P} .amc-quick-add-guidance.is-upgraded~.amc-card-option-modal__body .amc-card-option-modal__price,${P} form.is-upgraded .amc-home-option-price{display:none!important}
${P} .amc-home-option-fields{gap:18px!important}
${P} .amc-home-option-field label{display:flex!important;justify-content:space-between!important;gap:10px!important;margin-bottom:8px!important;font-size:11.5px!important;font-weight:900!important;letter-spacing:.07em!important;text-transform:uppercase!important;color:#5E7080!important}
${P} .amc-home-option-field label b{font-weight:800!important;letter-spacing:0!important;text-transform:none!important;color:#061A35!important;text-align:right!important}
${P} .amc-home-option-field select{min-height:52px!important;padding:10px 40px 10px 14px!important;border:1.5px solid #D5DAE1!important;border-radius:12px!important;background-color:#fff!important;color:#061A35!important;font-size:14px!important;font-weight:650!important}
${P} .amc-home-option-field select:focus-visible{border-color:#061A35!important;outline:2px solid #1A5CFF!important;outline-offset:2px!important}
${P} .amc-home-option-field select.is-pilled{position:absolute!important;width:1px!important;height:1px!important;min-height:0!important;padding:0!important;border:0!important;opacity:0!important;pointer-events:none!important}
${P} .amc-qa-pills{display:flex!important;flex-wrap:wrap!important;gap:8px!important}
${P} .amc-qa-pill{min-height:46px!important;padding:0 18px!important;border:1.5px solid #D5DAE1!important;border-radius:999px!important;background:#fff!important;color:#061A35!important;font:700 14px/1.2 inherit!important;cursor:pointer!important;transition:background .15s ease,border-color .15s ease,color .15s ease!important}
${P} .amc-qa-pill:hover{border-color:#061A35!important}
${P} .amc-qa-pill[aria-checked="true"]{border-color:#061A35!important;background:#061A35!important;color:#fff!important;-webkit-text-fill-color:#fff!important}
${P} .amc-qa-pill:disabled{border-style:dashed!important;background:#F5F5F7!important;color:#9AA4B1!important;text-decoration:line-through!important;cursor:not-allowed!important}
${P} .amc-home-option-status{margin:0!important;font-size:13px!important;font-weight:600!important;color:#5E7080!important}
${P} .amc-home-option-status.is-ready{color:#17804A!important}
${P} .amc-qa-foot{position:sticky!important;bottom:0!important;z-index:2!important;display:flex!important;flex-wrap:wrap!important;align-items:center!important;gap:10px!important;margin:4px -16px 0!important;padding:12px 16px calc(12px + env(safe-area-inset-bottom))!important;border-top:1px solid #E6E8EC!important;background:#fff!important}
${P} .amc-qa-foot .amc-card-qty{display:flex!important;flex:0 0 auto!important;align-items:center!important;height:50px!important;border:1.5px solid #D5DAE1!important;border-radius:999px!important;background:#fff!important;overflow:hidden!important}
${P} .amc-qa-foot .amc-card-qty button{width:40px!important;height:100%!important;border:0!important;background:#F5F5F7!important;color:#061A35!important;font-size:18px!important;font-weight:800!important;cursor:pointer!important}
${P} .amc-qa-foot .amc-card-qty input{width:44px!important;height:100%!important;padding:0!important;border:0!important;background:#fff!important;color:#061A35!important;font-size:15px!important;font-weight:800!important;text-align:center!important;-moz-appearance:textfield!important}
${P} .amc-qa-foot .amc-card-option-modal__submit{flex:1 1 190px!important;width:auto!important;min-width:0!important;padding:0 12px!important;white-space:nowrap!important;min-height:50px!important;margin:0!important;font-size:14.5px!important}
html:not(#a):not(#b):not(#c) body.index-template .amc-card-option-modal .amc-card-option-modal__submit:disabled{border-color:#C9CED6!important;background:#C9CED6!important;color:#fff!important;opacity:1!important;cursor:not-allowed!important}
${P} .amc-qa-details{display:block!important;padding:4px 0 18px!important;font-size:13px!important;font-weight:700!important;color:#061A35!important;text-align:center!important;text-decoration:underline!important;text-underline-offset:3px!important}
}`;
  const style = document.createElement('style');
  style.id = 'amc-quick-add-style';
  style.textContent = CSS;
  document.head.appendChild(style);

  const setLabel = (el, text) => {
    let label = el.querySelector(':scope > span:not([aria-hidden])');
    if (!label) {
      [...el.childNodes].forEach((node) => { if (node.nodeType === 3) node.remove(); });
      el.querySelectorAll(':scope > span[aria-hidden]').forEach((arrow) => arrow.remove());
      label = document.createElement('span');
      el.prepend(label);
    }
    label.textContent = text;
    return label;
  };

  const productName = (el) => {
    const card = el.closest(CARD);
    const heading = card ? card.querySelector('h3, h4, .amc-cslider__title, .card__heading') : null;
    return heading ? heading.textContent.replace(/\s+/g, ' ').trim() : 'this product';
  };

  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  };

  // ---- Options flyout upgrade -------------------------------------------------
  const upgrade = (dialog, opener) => {
    if (!dialog || dialog.dataset.amcQaUpgraded) return;
    const form = dialog.querySelector('form[data-amc-home-option-form]');
    const head = dialog.querySelector('.amc-quick-add-guidance');
    const submit = form ? form.querySelector('button[type="submit"]') : null;
    if (!form || !head || !submit) return;
    dialog.dataset.amcQaUpgraded = 'true';
    const closeButton = dialog.querySelector('.popup-modal__toggle');
    if (closeButton) closeButton.setAttribute('data-modal-close', '');

    const card = opener ? opener.closest(CARD) : null;
    const cardImage = card ? card.querySelector('img') : null;
    const cardLink = card ? card.querySelector('a[href*="/products/"]') : null;
    const cardPrice = card ? card.querySelector('.amc-card-price__amount') : null;
    const oldPrice = dialog.querySelector('.amc-card-option-modal__price');
    const gloveTemplate = card ? card.querySelector('[data-amc-glove-unit]') : null;
    const gloveBoxes = gloveTemplate ? Number(gloveTemplate.dataset.boxes) : 0;
    let variants = [];
    try { variants = JSON.parse(form.querySelector('[data-amc-option-variants]').textContent || '[]'); } catch (_) { variants = []; }
    const variantInput = form.querySelector('[data-amc-option-variant-id]');
    const choices = [...form.querySelectorAll('[data-amc-option-choice]')];
    const fallbackPrice = ((gloveTemplate && gloveTemplate.textContent) || (cardPrice && cardPrice.textContent) || (oldPrice && oldPrice.textContent) || '').replace(/\s+/g, ' ').trim();

    // Header: photo, name, live price.
    const kicker = head.querySelector('strong');
    const kickerText = kicker ? kicker.textContent.trim() : 'Choose options';
    const thumb = el('span', 'amc-qa-thumb');
    const image = el('img');
    image.alt = '';
    image.decoding = 'async';
    const baseImage = cardImage ? (cardImage.currentSrc || cardImage.src) : '';
    if (baseImage) image.src = baseImage;
    thumb.append(image);
    const price = el('span', 'amc-qa-price', fallbackPrice);
    price.setAttribute('aria-live', 'polite');
    head.replaceChildren(thumb, el('span', 'amc-qa-kicker', kickerText), el('span', 'amc-qa-title', card ? productName(card) : kickerText), price);
    head.classList.add('is-upgraded');
    form.classList.add('is-upgraded');

    // Option buttons for short lists; long lists stay as menus.
    const groups = choices.map((choice) => {
      if (choice.tagName !== 'SELECT') return null;
      const field = choice.closest('.amc-home-option-field');
      const label = field ? field.querySelector('label') : null;
      const chosen = el('b');
      const values = [...choice.options].filter((option) => option.value);
      const group = { choice, chosen, pills: [] };
      if (values.length && values.length <= 6 && values.every((option) => option.value.length <= 28)) {
        const row = el('div', 'amc-qa-pills');
        row.setAttribute('role', 'radiogroup');
        if (label) row.setAttribute('aria-label', label.firstChild ? label.firstChild.textContent.trim() : 'Option');
        values.forEach((option) => {
          const pill = el('button', 'amc-qa-pill', option.value);
          pill.type = 'button';
          pill.setAttribute('role', 'radio');
          pill.setAttribute('aria-checked', 'false');
          pill.addEventListener('click', () => {
            choice.value = option.value;
            choice.dispatchEvent(new Event('change', { bubbles: true }));
          });
          group.pills.push(pill);
          row.append(pill);
        });
        choice.classList.add('is-pilled');
        choice.tabIndex = -1;
        choice.setAttribute('aria-hidden', 'true');
        choice.after(row);
        if (label) label.append(chosen);
      }
      return group;
    });

    // Pinned footer: quantity (when the card has none wired to this form) + Add to Cart.
    const foot = el('div', 'amc-qa-foot');
    submit.before(foot);
    if (!form.elements.quantity) {
      const qty = el('div', 'amc-card-qty');
      const minus = el('button', '', '−');
      minus.type = 'button';
      minus.setAttribute('aria-label', 'Decrease quantity');
      const input = el('input');
      input.type = 'number';
      input.name = 'quantity';
      input.value = '1';
      input.min = '1';
      input.step = '1';
      input.inputMode = 'numeric';
      input.setAttribute('aria-label', 'Quantity');
      const plus = el('button', '', '+');
      plus.type = 'button';
      plus.setAttribute('aria-label', 'Increase quantity');
      qty.append(minus, input, plus);
      foot.append(qty);
    }
    foot.append(submit);
    if (gloveBoxes > 0 && form.elements.quantity) form.elements.quantity.setAttribute('aria-label', 'Quantity (cases)');
    const quoteActions = form.querySelector('[data-amc-qbtn]');
    if (quoteActions) foot.append(quoteActions);
    const submitLabel = submit.querySelector('span') || submit;
    if (cardLink) {
      const details = el('a', 'amc-qa-details', 'View full details');
      details.href = cardLink.getAttribute('href');
      foot.after(details);
    }

    const sync = () => {
      const selected = choices.map((choice) => choice.value || '');
      const variant = variantInput && variantInput.value ? variants.find((candidate) => String(candidate.id) === String(variantInput.value)) : null;
      groups.forEach((group, index) => {
        if (!group) return;
        group.chosen.textContent = group.choice.value || '';
        group.pills.forEach((pill) => {
          const value = pill.textContent;
          pill.setAttribute('aria-checked', String(group.choice.value === value));
          // Grey out a value no available variant offers with the other current selections.
          pill.disabled = !variants.some((candidate) => candidate.available && candidate.options && candidate.options[index] === value &&
            candidate.options.every((optionValue, position) => position === index || !selected[position] || selected[position] === optionValue));
        });
      });
      if (variant) {
        price.replaceChildren();
        if (variant.compare_at_price > variant.price) {
          const comparison = el('span', 'amc-qa-comparison');
          comparison.style.cssText = 'display:flex;align-items:center;gap:7px;flex:0 0 100%;font-size:12px';
          comparison.append(el('span', '', 'Sale'), el('s', '', money(variant.compare_at_price)));
          comparison.firstElementChild.style.color='#D71920';
          price.append(comparison);
        }
        if (gloveTemplate && gloveBoxes > 0) {
          const unit = gloveTemplate.cloneNode(true);
          unit.querySelector('.amc-glove-unit__box').textContent = money(Math.round(variant.price / gloveBoxes)) + '/box';
          unit.querySelector('.amc-glove-unit__case').textContent = money(variant.price) + ' per case';
          unit.dataset.caseCents = String(variant.price);
          unit.dataset.variantId = String(variant.id);
          price.append(unit);
        } else {
          price.append(el('strong', '', money(variant.price)));
        }
        const variantImage = variant.featured_image && variant.featured_image.src;
        image.src = variantImage ? variantImage + (variantImage.includes('?') ? '&' : '?') + 'width=240' : (baseImage || image.src);
        const requestedQuantity = Number(form.elements.quantity?.value || 1);
        const quantity = Number.isSafeInteger(requestedQuantity) && requestedQuantity > 0 ? requestedQuantity : 1;
        submitLabel.textContent = (gloveBoxes > 0 ? 'Add ' + quantity + ' case' + (quantity === 1 ? '' : 's') + ' · ' : 'Add to cart · ') + money(variant.price * quantity);
      } else {
        if (gloveTemplate && gloveBoxes > 0) price.replaceChildren(gloveTemplate.cloneNode(true));
        else price.textContent = fallbackPrice;
        if (baseImage) image.src = baseImage;
        submitLabel.textContent = 'Add to cart';
      }
      delete submit.dataset.amcLabel;
    };
    form.addEventListener('change', sync);
    form.addEventListener('input', sync);
    sync();
  };

  // ---- Card buttons -----------------------------------------------------------
  const enhance = () => {
    document.querySelectorAll('modal-opener .amc-market-card__atc:not([data-amc-qa])').forEach((button) => {
      button.dataset.amcQa = 'flyout';
      setLabel(button, LABEL);
      button.setAttribute('aria-label', LABEL + ': ' + productName(button) + '. Opens options.');
    });
    document.querySelectorAll(LINKS).forEach((link) => {
      if (link.dataset.amcQa) return;
      // Built-to-order products (walk-ins, hinge/door coolers, builders) open the product page's own
      // builder in a side flyout, so required choices and the built-in discount match the product page.
      if (link.classList.contains('amc-market-card__cta')) {
        link.dataset.amcQa = 'builder';
        setLabel(link, 'Configure');
        link.setAttribute('aria-label', 'Configure ' + productName(link) + '. Opens build options.');
        return;
      }
      link.dataset.amcQa = 'fetch';
      setLabel(link, LABEL);
      link.setAttribute('aria-label', LABEL + ': ' + productName(link) + '. Opens options and quantity.');
    });
  };

  const settled = (form) => new Promise((resolve) => {
    const started = Date.now();
    (function check() {
      if (form.dataset.amcSubmitting !== 'true' || Date.now() - started > 45000) resolve();
      else setTimeout(check, 120);
    })();
  });

  const load = async (link) => {
    const path = new URL(link.href, window.location.href).pathname;
    if (hosts.has(path)) return hosts.get(path);
    const response = await fetch(path + '?section_id=amc-quick-add', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('Quick add unavailable');
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const source = parsed.querySelector('[data-amc-qa-kind]');
    if (!source) throw new Error('Quick add unavailable');
    const host = document.importNode(source, true);
    document.body.appendChild(host);
    host.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
    hosts.set(path, host);
    return host;
  };

  // Existing shelf flyouts: upgrade right after the shelf script creates them.
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('modal-opener[data-modal]');
    if (!opener) return;
    const selector = opener.getAttribute('data-modal');
    const run = () => { try { upgrade(document.querySelector(selector), opener); } catch (_) {} };
    run();
    setTimeout(run, 0);
  }, true);

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('a[data-amc-qa="fetch"]');
    if (!link || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.dataset.amcBusy) return;
    link.dataset.amcBusy = 'true';
    link.setAttribute('aria-busy', 'true');
    const label = setLabel(link, 'Opening…');
    try {
      const host = await load(link);
      const kind = host.dataset.amcQaKind;
      const form = host.querySelector('form[data-amc-home-cart-form]');
      const instinct = Boolean(link.closest('[data-amc-instinct]')) && !link.closest('[data-amc-cot-rail]');
      if(form){form.dataset.amcQuietCart=String(instinct);form.amcOrigin=link;}
      const simpleInstinct=instinct&&host.dataset.amcQaDefault==='true'&&form&&!form.querySelector('[data-amc-cot-accessories],[data-amc-option-choice]:not([type="hidden"])');
      if (kind === 'direct' || simpleInstinct) {
        const form = host.querySelector('form[data-amc-home-cart-form]');
        const submit = form.querySelector('button[type="submit"]');
        form.dispatchEvent(new CustomEvent('shopify:section:load',{bubbles:true}));
        if(!form.querySelector('[name="id"]')?.value||submit.disabled)throw new Error('Choose product options first.');
        form.requestSubmit(submit);
        await settled(form);
        const error = form.querySelector('.amc-home-cart-error');
        if (error && !error.hidden && error.textContent.trim()) throw new Error(error.textContent);
      } else if (kind === 'options' && typeof host.show === 'function') {
        try { upgrade(host, link); } catch (_) {}
        host.classList.remove('hidden-during-load');
        host.show(link);
        requestAnimationFrame(()=>host.querySelector('.amc-qa-pill:not(:disabled),select[data-amc-option-choice],input[name="quantity"]')?.focus());
      } else {
        throw new Error('Quick add unavailable');
      }
    } catch (_) {
      // Anything else (built-to-order products): open the product page's own buy box in the flyout.
      openBuilder(link);
    } finally {
      delete link.dataset.amcBusy;
      link.removeAttribute('aria-busy');
      if(link.dataset.amcInstinctAdded!=='true')label.textContent = LABEL;
    }
  }, true);


  // ---- Builder flyout ---------------------------------------------------------
  // Built-to-order products (walk-ins, door/hinge coolers, builders) collect their required choices in the
  // product page builder as line item properties, so they are never added from a card. Shopify does not
  // allow storefront pages inside a frame, and the builder scripts read the product page itself, so this
  // flyout shows the photo, live price and built-in savings, then hands off to the builder with one tap.
  const BF_CSS = `
.amc-bf{position:fixed;inset:0;z-index:2147483000;display:flex;justify-content:flex-end}
.amc-bf[hidden]{display:none}
.amc-bf__scrim{position:absolute;inset:0;background:rgba(6,26,53,.42);opacity:0;transition:opacity .2s ease}
.amc-bf.is-open .amc-bf__scrim{opacity:1}
.amc-bf__panel{position:relative;display:flex;flex-direction:column;width:min(560px,100vw);height:100%;background:#fff;box-shadow:-12px 0 32px rgba(6,26,53,.18);transform:translateX(100%);transition:transform .24s ease}
.amc-bf.is-open .amc-bf__panel{transform:none}
.amc-bf__head{display:grid;grid-template-columns:56px 1fr 40px;gap:12px;align-items:center;padding:12px 14px;border-bottom:1px solid #E6E8EC;background:#fff}
.amc-bf__thumb{width:56px;height:56px;border:1px solid #E6E8EC;border-radius:8px;background:#fff;overflow:hidden;display:flex;align-items:center;justify-content:center}
.amc-bf__thumb img{width:100%;height:100%;object-fit:contain}
.amc-bf__kicker{display:block;font:700 11px/1.2 inherit;letter-spacing:.08em;text-transform:uppercase;color:#D71920}
.amc-bf__title{display:block;margin-top:2px;font:700 15px/1.25 inherit;color:#061A35;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}
.amc-bf__price{display:block;margin-top:2px;font:700 14px/1.2 inherit;color:#D71920}
.amc-bf__close{width:40px;height:40px;border:1px solid #E6E8EC;border-radius:999px;background:#fff;color:#061A35;font-size:22px;line-height:1;cursor:pointer}
.amc-bf__close:focus-visible{outline:2px solid #152D45;outline-offset:2px}
.amc-bf__body{flex:1;min-height:0;overflow:auto;padding:16px}
.amc-bf__hero{display:flex;align-items:center;justify-content:center;aspect-ratio:4/3;border:1px solid #E6E8EC;border-radius:12px;background:#fff;overflow:hidden}
.amc-bf__hero img{width:100%;height:100%;object-fit:contain}
.amc-bf__prices{display:flex;flex-wrap:wrap;align-items:baseline;gap:8px;margin:16px 0 4px}
.amc-bf__now{font-size:26px;font-weight:800;color:#061A35}
.amc-bf__was{color:#6B7785;text-decoration:line-through;font-size:15px}
.amc-bf__save{display:inline-flex;align-items:center;min-height:24px;padding:0 10px;border-radius:999px;background:#D71920;color:#fff;font-size:12px;font-weight:800}
.amc-bf__promo{margin:10px 0 0;padding:10px 12px;border-radius:10px;background:#FFF8D6;border:1px solid #FFDE17;color:#152D45;font-size:13.5px;line-height:1.4}
.amc-bf__promo b{color:#061A35}
.amc-bf__steps{margin:16px 0 0;padding:0;list-style:none;display:grid;gap:8px}
.amc-bf__steps li{display:flex;gap:10px;align-items:center;padding:10px 12px;border:1px solid #E6E8EC;border-radius:10px;color:#152D45;font-size:14px;font-weight:600}
.amc-bf__steps li::before{content:"";flex:0 0 8px;height:8px;border-radius:50%;background:#1D63C9}
.amc-bf__note{margin:12px 0 0;color:#5B6B7B;font-size:12.5px;line-height:1.45}
.amc-bf__foot{padding:12px 16px calc(12px + env(safe-area-inset-bottom));border-top:1px solid #E6E8EC;background:#fff}
.amc-bf__go{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;min-height:52px;border-radius:999px;background:#1D63C9;color:#fff!important;-webkit-text-fill-color:#fff;font-weight:800;font-size:16px;text-decoration:none!important}
.amc-bf__go:hover{background:#164FA3}
.amc-bf__go:focus-visible{outline:2px solid #152D45;outline-offset:3px}
@media (prefers-reduced-motion:reduce){.amc-bf__panel,.amc-bf__scrim{transition:none}}
@media (max-width:749px){.amc-bf__panel{width:100vw}}
@layer amcHeaderControls{
html:is(html,#q#q#q#q#q#q#q#q#q#q#q#q) body.index-template :is(.amc-market-card__cta,.amc-market-card__atc,.amc-cslider__action,a.amc-equipment-product__link,a.amc-cslider__quick){background:#1D63C9!important;border:1px solid #1D63C9!important;color:#fff!important;-webkit-text-fill-color:#fff!important;border-radius:999px!important;box-shadow:none!important;text-transform:none!important;letter-spacing:0!important;font-weight:700!important;justify-content:center!important}
html:is(html,#q#q#q#q#q#q#q#q#q#q#q#q) body.index-template :is(.amc-market-card__cta,.amc-market-card__atc,.amc-cslider__action,a.amc-equipment-product__link,a.amc-cslider__quick):hover{background:#164FA3!important;border-color:#164FA3!important}
html:is(html,#q#q#q#q#q#q#q#q#q#q#q#q) body.index-template :is(.amc-market-card__cta,.amc-market-card__atc,.amc-cslider__action) :is(span[aria-hidden],svg){display:none!important}
html:is(html,#q#q#q#q#q#q#q#q#q#q#q#q) body.index-template .amc-card-quote-trigger{display:none!important}
html:is(html,#q#q#q#q#q#q#q#q#q#q#q#q) body.index-template .amc-card-option-modal :is([data-amc-qbtn],.amc-qbtn){display:none!important}
}
`;
  const bfStyle = document.createElement('style');
  bfStyle.id = 'amc-builder-flyout-style';
  bfStyle.textContent = BF_CSS;
  document.head.appendChild(bfStyle);

  let bf = null;
  const builderParts = () => {
    if (bf) return bf;
    const root = el('div', 'amc-bf');
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', 'amc-bf-title');
    const scrim = el('div', 'amc-bf__scrim');
    const panel = el('div', 'amc-bf__panel');
    const head = el('div', 'amc-bf__head');
    const thumb = el('span', 'amc-bf__thumb');
    const img = el('img');
    img.alt = '';
    thumb.append(img);
    const text = el('div');
    const title = el('span', 'amc-bf__title');
    title.id = 'amc-bf-title';
    const price = el('span', 'amc-bf__price');
    text.append(el('span', 'amc-bf__kicker', 'Add To Cart'), title, price);
    const close = el('button', 'amc-bf__close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    head.append(thumb, text, close);
    const body = el('div', 'amc-bf__body');
    const foot = el('div', 'amc-bf__foot');
    const go = el('a', 'amc-bf__go', 'Choose Build & Add To Cart');
    foot.append(go);
    panel.append(head, body, foot);
    root.append(scrim, panel);
    document.body.appendChild(root);
    bf = { root, img, title, price, body, go, close, opener: null };
    const hide = () => closeBuilder();
    scrim.addEventListener('click', hide);
    close.addEventListener('click', hide);
    root.addEventListener('keydown', (event) => { if (event.key === 'Escape') hide(); });
    return bf;
  };

  const closeBuilder = () => {
    if (!bf || bf.root.hidden) return;
    bf.root.classList.remove('is-open');
    document.documentElement.style.removeProperty('overflow');
    setTimeout(() => { bf.root.hidden = true; }, 240);
    if (bf.opener && bf.opener.focus) bf.opener.focus();
  };

  const stepsFor = (product) => {
    const type = String((product && product.type) || '');
    const words = (type + ' ' + ((product && product.title) || '')).toLowerCase();
    if (/walk[\s-]?in|freezer/.test(words)) return ['Size and layout', 'Door side and door options', 'Refrigeration system', 'Build-out add-ons'];
    if (/hybrid|roll[\s-]?in|triple|double/.test(words)) return ['Configuration and layout', 'Door hinge side', 'Refrigeration and add-ons'];
    return ['Door hinge side', 'Options and add-ons'];
  };

  const renderBuilder = (product, link) => {
    const parts = bf;
    const variant = product && (product.variants || []).find((v) => v.available) || (product && product.variants && product.variants[0]);
    const cents = variant ? variant.price : (product ? product.price : 0);
    const compare = variant ? (variant.compare_at_price || 0) : 0;
    const nfda = window.AMCNfda && product && typeof window.AMCNfda.eligible === 'function' && window.AMCNfda.eligible(product.id);
    const off = nfda ? Math.floor(cents * 5 / 100) : 0;
    const body = parts.body;
    body.replaceChildren();
    const hero = el('div', 'amc-bf__hero');
    const heroImg = el('img');
    heroImg.alt = product ? product.title : '';
    const src = (product && (product.featured_image || (product.images || [])[0])) || parts.img.src;
    if (src) heroImg.src = String(src).replace(/^\/\//, 'https://') + (String(src).includes('?') ? '&' : '?') + 'width=900';
    hero.append(heroImg);
    body.append(hero);
    if (cents) {
      const row = el('div', 'amc-bf__prices');
      const from = product && product.price_varies ? 'From ' : '';
      row.append(el('span', 'amc-bf__now', from + money(cents - off)));
      if (off) row.append(el('span', 'amc-bf__was', money(cents)));
      else if (compare > cents) row.append(el('span', 'amc-bf__was', money(compare)));
      const save = off || (compare > cents ? compare - cents : 0);
      if (save) row.append(el('span', 'amc-bf__save', 'Save ' + money(save)));
      body.append(row);
      parts.price.textContent = from + money(cents - off);
    }
    if (off) {
      const promo = el('p', 'amc-bf__promo');
      promo.append(el('b', '', 'NFDA savings: 5% off the walk-in base, applied automatically. '), document.createTextNode('No code needed. The saving shows on your build and in your cart.'));
      body.append(promo);
    }
    const steps = el('ul', 'amc-bf__steps');
    steps.setAttribute('aria-label', 'Choices in your build');
    stepsFor(product).forEach((step) => steps.append(el('li', '', step)));
    body.append(el('p', 'amc-bf__note', 'Built to order. Pick these on the next screen, then your complete build goes into the cart:'), steps);
    parts.go.href = link.href;
  };

  const openBuilder = async (link) => {
    // Required choices live on the product page; skip the redundant summary flyout.
    const buildUrl = new URL(link.href, location.href);
    buildUrl.searchParams.set('configure', '1');
    location.assign(buildUrl.href);
    return;

    const parts = builderParts();
    const card = link.closest(CARD);
    const cardImage = card ? card.querySelector('img') : null;
    const cardPrice = card ? card.querySelector('.amc-card-price__amount, .price-item--sale, .price-item--regular, .amc-cslider__price') : null;
    parts.opener = link;
    parts.title.textContent = card ? productName(card) : 'Your build';
    parts.price.textContent = cardPrice ? cardPrice.textContent.replace(/\s+/g, ' ').trim() : '';
    parts.img.src = cardImage ? (cardImage.currentSrc || cardImage.src) : '';
    parts.img.parentElement.style.display = parts.img.src ? '' : 'none';
    parts.go.href = link.href;
    parts.body.replaceChildren(el('p', 'amc-bf__note', 'Loading…'));
    parts.root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => parts.root.classList.add('is-open'));
    setTimeout(() => parts.close.focus(), 60);
    let product = null;
    try {
      const path = new URL(link.href, window.location.href).pathname.replace(/\/$/, '');
      const response = await fetch(path + '.js', { credentials: 'same-origin' });
      if (response.ok) product = await response.json();
    } catch (_) {}
    renderBuilder(product, link);
  };
  window.amcOpenBuilder = openBuilder;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-amc-qa="builder"]');
    if (!link || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    openBuilder(link);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once: true });
  else enhance();
  document.addEventListener('shopify:section:load', () => setTimeout(enhance, 0));
})();

/* 2026-10-22: homepage cards for NFDA26-eligible products show the automatic 5% the same way as compare-at sale
   cards (struck price, discounted price, red Save). Uses window.AMCNfda (real eligible list + campaign dates),
   so the line disappears on its own when the campaign ends. */
(function(){
  if(!document.body||!document.body.classList.contains('index-template'))return;
  var money=function(c){return new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(c/100)};
  var cache={};
  function handleOf(card){var a=card.querySelector('a.amc-market-card__media-link[href],h3 a[href]');var m=a&&a.getAttribute('href').match(/\/products\/([^/?#]+)/);return m?m[1]:''}
  function run(){
    var N=window.AMCNfda;if(!N||typeof N.savings!=='function'||!N.active())return;
    document.querySelectorAll('.amc-market-card .amc-card-price--regular:not([data-amc-nfda])').forEach(function(box){
      var pid=box.getAttribute('data-amc-pid'),cents=parseInt(box.getAttribute('data-amc-cents'),10);
      box.setAttribute('data-amc-nfda','0');if(!pid||!cents)return;
      (function(p){
        if(!p)return;var off=N.savings(p.id,p.price);if(!off)return;
        var amt=box.querySelector('.amc-card-price__amount'),list=box.querySelector('.amc-card-price__list'),det=box.querySelector('.amc-card-price__details');if(!amt||!list)return;
        var from=/^\s*from/i.test(amt.textContent);
        box.setAttribute('data-amc-nfda','1');
        box.classList.remove('amc-card-price--regular');box.classList.add('amc-card-price--sale');
        list.removeAttribute('aria-hidden');
        list.innerHTML='<span style="color:#D71920;font-weight:650">Sale</span><s aria-label="List price" style="color:#607083;font-weight:450">'+money(p.price)+'</s>';
        amt.textContent=(from?'From ':'')+money(p.price-off);
        box.querySelectorAll('.amc-card-price__mobile-summary,.amc-card-price__details').forEach(function(row){row.remove()});
        amt.setAttribute('title','NFDA26 5% applied automatically in cart');
      })({id:pid,price:cents});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
  addEventListener('load',run,{once:true});
  document.addEventListener('shopify:section:load',run);
})();
